import React from "react";
import PqrsdForm from "../pqrsd/PqrsdForm";

export default function LayoutPqrsd() {
  return <PqrsdForm />;
}

